import React, { useState } from "react";
import AccordionItem from "./AccordionItem";

const Accordion = ({ children }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div>
      {React.Children.map(children, (child, index) => {
        return React.cloneElement(child, {
          isOpen: openIndex === index,
          onToggle: () => toggle(index),
        });
      })}
    </div>
  );
};

export default Accordion;
